import Api from './BaseRequest';

const GetCalendarSettings = () => {
    return Api.Get('/api/calendar/settings')
}

const GetDays = (start, end) => {
    return Api.Get('/api/calendar/day-range', { start, end })
}

const GetSlots = (date, teacherId, productId) => {
    if (teacherId) {
        return Api.Get('/api/calendar/slots', { date, teacherId, productId })
    }
    return Api.Get('/api/calendar/slots', { date, productId })
};

const GetNextAvailableDate = (date, teacherId, productId) => {
    if (teacherId) {
        return Api.Get('/api/calendar/next_available', { start: date, teacherId, productId })
    }
    return Api.Get('/api/calendar/next_available', { start: date, productId })
};

const Booking = (data) => {
    return Api.Post('/api/booking/request', data)
};

const CancelBooking = (id) => {
    return Api.Delete('/api/booking/cancel', { id })
};

const GetProducts = () => {
    return Api.Get('api/calendar/products')
}

const GetSelectOptions = (classId) => {
    return Api.Get('api/calendar/get-select-options?classId=' + (classId ? classId : ''))
}

export default {
    Settings: GetCalendarSettings,
    GetDays,
    GetSlots,
    GetNextAvailableDate,
    Booking,
    CancelBooking,
    GetProducts,
    GetSelectOptions,
}
